import {Flex, ThemeProvider, View} from "@aws-amplify/ui-react"
import Header from "components/layout/Header/Header"
import basicTheme from "components/layout/themes/basicTheme"
import "./Basic.css"
import * as React from "react"
import {useState} from "react"
import {Outlet} from "react-router-dom"
import {Toast} from "../common/Toast/Toast"
import Footer from "./Footer/Footer"

export default function Basic({children}) {
    const mainContentRef = React.useRef(null)
    const [toast, setToast] = useState()

    return <ThemeProvider theme={ basicTheme }>
        <Header mainContentRef={ mainContentRef } />
        <View width="100%">
            <Flex
                id="main"
                as="main"
                ref={ mainContentRef }
                direction="column"
                padding={ "0 3.5rem 2.0rem" }
                margin="auto"
                maxWidth="1800px"
            >
                <Toast toast={ toast } setToast={ setToast } />
                { children }
                <Outlet />
            </Flex>
        </View>

        <Footer />
    </ThemeProvider>
}
